// extracted by mini-css-extract-plugin
export default {"markdown":"Markdown_markdown__oEAnG"};